import axios from "axios";
import {
  API_URL_SOFTWARE_GENERATE_BY_AI,

} from '../constants';

import { API_BASE_URL } from "../constants";


export default class DataProtectionSoftwareService {
  static instance;
  resource = `${API_BASE_URL}/software/`;

  constructor() {}

  static getInstance() {
    if (!DataProtectionSoftwareService.instance) {
      DataProtectionSoftwareService.instance =
        new DataProtectionSoftwareService();
    }

    return DataProtectionSoftwareService.instance;
  }

  async list(filters) {
    const response = await axios.get(`${this.resource}list`, {
      params: filters,
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async SoftwareFetch() {
    const response = await axios.get(`${this.resource}fetch`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data;
  }

  async getCount() {
    const response = await axios.get(`${this.resource}count`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data;
  }

  async aiRiskAssessmentDashboard(params = {}) {
    const response = await axios.get(`${API_BASE_URL}/dashboard`, {
      params: {
        questionnaire_name: "ai_risk_assessment",
        ...params,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async providers(pageSize, pageIndex, sortOrder, sortField) {
    const response = await axios.get(`${this.resource}providers`, {
      params: {
        pageSize,
        pageIndex,
        sortOrder,
        sortField,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async modules() {
    const response = await axios.get(`${this.resource}modules`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async addModule(payload) {
    const response = await axios.post(`${this.resource}add_module`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async removeModule(payload) {
    const response = await axios.post(
      `${this.resource}remove_module`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async operatingSystems(pageSize, pageIndex, sortOrder, sortField) {
    const response = await axios.get(`${this.resource}operating_systems`, {
      params: {
        pageSize,
        pageIndex,
        sortOrder,
        sortField,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async types(pageSize, pageIndex, sortOrder, sortField) {
    const response = await axios.get(`${this.resource}types`, {
      params: {
        pageSize,
        pageIndex,
        sortOrder,
        sortField,
      },
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async create(items) {
    const response = await axios.post(`${this.resource}create`, items, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async generateByAI(items) {

    const response = await axios.post(`${API_URL_SOFTWARE_GENERATE_BY_AI}`, items, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
        Accept: "application/json", 
      },
    });

    return response?.data?.message;
  }

  async analyzeUrl(payload) {
    const response = await axios.post(`${this.resource}analyze_url`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
        Accept: "application/json",
      },
    });

    return response?.data?.data?.prefill || response?.data?.prefill || {};
  }

  async downloadCSV() {
    const response = await axios.get(`${this.resource}download`, {
      maxBodyLength: Infinity,
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data;
  }

  async downloadTemplate() {
    const response = await axios.get(`${this.resource}download_csv_template`, {
      maxBodyLength: Infinity,
      responseType: "arraybuffer",
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data;
  }

  async changeStatus(data) {
    const response = await axios.put(`${this.resource}change_status`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async changeAssignedAnalyst(data) {
    const response = await axios.post(`${this.resource}change_analyst`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });
    return response.data.data;
  }

  async changePriority(data) {
    const response = await axios.put(`${this.resource}change_priority`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async AddEntity(data) {
    const response = await axios.post(`${this.resource}add_legal`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`
      },
    });

    return response.data.data;
  }

  async RemoveEntity(data) {
    const response = await axios.delete(`${this.resource}remove_legal`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
        },
        data: data // Pass the data here
    });

    return response.data.data;
}

  async details(softwareId) {
    const response = await axios.get(`${this.resource}${softwareId}/show`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }
  
  async fetchApprovalRequirements(softwareId) {
    const response = await axios.get(
      `${this.resource}${softwareId}/approval-requirements`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data?.data ?? response.data;
  }

  async fetchApprovalRequirement(softwareId, requirementId) {
    const response = await axios.get(
      `${this.resource}${softwareId}/approval-requirements/${requirementId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data?.data ?? response.data;
  }

  async submitApprovalRequirementAction(softwareId, requirementId, payload) {
    const url = `${this.resource}${softwareId}/approval-requirements/${requirementId}/action`;
    const headers = {
      Authorization: `Bearer ${localStorage.getItem(
        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
      )}`,
    };

    try {
      const response = await axios.post(url, payload, { headers });

      return response.data?.data ?? response.data;
    } catch (error) {
      if (error?.response?.status !== 405) {
        throw error;
      }

      const response = await axios.patch(url, payload, { headers });

      return response.data?.data ?? response.data;
    }
  }

  async fetchApprovalEligibleAssignees(softwareId, requirementId) {
    const response = await axios.get(
      `${this.resource}${softwareId}/approval-requirements/${requirementId}/eligible-assignees`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data?.data ?? response.data;
  }

  async assignApprovalRequirement(softwareId, requirementId, payload) {
    const url = `${this.resource}${softwareId}/approval-requirements/${requirementId}/assign`;
    const headers = {
      Authorization: `Bearer ${localStorage.getItem(
        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
      )}`,
    };

    try {
      const response = await axios.post(url, payload, { headers });

      return response.data?.data ?? response.data;
    } catch (error) {
      if (error?.response?.status !== 405) {
        throw error;
      }

      const response = await axios.patch(url, payload, { headers });

      return response.data?.data ?? response.data;
    }
  }

  async fetchComplianceOverview(softwareId) {
    const response = await axios.get(
      `${this.resource}${softwareId}/compliance/overview`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        }
      }
    );

    return response.data?.data ?? response.data;
  }

  async fetchComplianceRecommendedActions(softwareId, { limit } = {}) {
    const params = {};

    if (limit != null && limit !== "") {
      params.limit = limit;
    }

    const response = await axios.get(
      `${this.resource}${softwareId}/compliance/recommended-actions`,
      {
        params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        }
      }
    );

    return response.data;
  }

  async fetchComplianceAi(softwareId) {
    const response = await axios.get(
      `${this.resource}${softwareId}/compliance/ai`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        }
      }
    );

    return response.data?.data ?? response.data;
  }

  async generateComplianceAi(softwareId, { type, force = false } = {}) {
    const response = await axios.post(
      `${this.resource}${softwareId}/compliance/ai/generate`,
      {
        type,
        force
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        }
      }
    );

    return response.data?.data ?? response.data;
  }

  async assessmentCards(softwareId) {
    const response = await axios.get(
      `${this.resource}${softwareId}/compliance/assessment-cards`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        }
      }
    );

    return response.data?.data ?? response.data;
  }

  async complianceModule(softwareId, slug) {
    const response = await axios.get(
      `${this.resource}${softwareId}/compliance/modules`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
        params: {
          slug
        }
      }
    );

    return response.data?.data ?? response.data;
  }

  async retryAiSetup(softwareId) {
    const response = await axios.post(
      `${this.resource}${softwareId}/retry-ai-setup`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async updateDetails(softwareId, payload) {
    const response = await axios.post(
      `${this.resource}${softwareId}/edit`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async uploadCSV(formData) {
    const response = await axios.post(`${this.resource}upload_csv`, formData, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async delete(id, reason, erasedBy, erasedAt) {
    if (!id) {
      return;
    }

    const data = {
      reason: reason,
      erasedBy: erasedBy,
      erasedAt: erasedAt,
    };
    const response = await axios.post(`${this.resource}${id}/delete`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async filledQuestionnaires(softwareId, questionnaireType) {
    const response = await axios.get(
      `${this.resource}${softwareId}/questionnaire_type/${questionnaireType}/list`,
      {
        params: {},
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );
    // console.log("RES", response, `${this.resource}${softwareId}/questionnaire_type/${questionnaireType}/list`)
    return response.data.data;
  }

  async toggleFlag(data) {
    const response = await axios.put(`${this.resource}toggle_flag`, data, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async changeDepartment(payload) {
    const response = await axios.post(
      `${this.resource}change_responsible_department`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async changePhoneNumber(payload) {
    const response = await axios.post(
      `${this.resource}change_phone_number`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async changeNotice(payload) {
    const response = await axios.post(
      `${this.resource}change_notice`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async changeIntendedPurpose(payload) {
    const response = await axios.post(
      `${this.resource}change_intended_purpose`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async changeEmail(payload) {
    const response = await axios.post(`${this.resource}change_email`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async changePosition(payload) {
    const response = await axios.post(
      `${this.resource}change_position`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async changeCompany(payload) {
    const response = await axios.post(
      `${this.resource}change_company`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  async changeResponsiblePerson(payload) {
    const response = await axios.post(
      `${this.resource}change_responsible_person`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // DPA
  async listDPA(id) {
    const response = await axios.get(`${API_BASE_URL}/dpa/${id}/detail`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  // Consultation
  async toggleConsultation(id) {
    const response = await axios.post(
      `${API_BASE_URL}/dpa/${id}/toggle_consultation_required`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Reason
  async toggleReason(payload) {
    const response = await axios.post(
      `${API_BASE_URL}/dpa/update_reason`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Date
  async updateDate(payload) {
    const response = await axios.post(
      `${API_BASE_URL}/dpa/update_date`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // Result
  async updateResult(payload) {
    const response = await axios.post(
      `${API_BASE_URL}/dpa/update_result`,
      payload,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );

    return response.data.data;
  }

  // History Logs
  async fetchLogs(assetId, params = {}) {
    const response = await axios.get(
      `${API_BASE_URL}/logs?softwareId=${assetId}`,
      {
        params: params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );
    return response.data.data;
  }

  async fetchLogDetails(logId, params = {}) {
    const response = await axios.get(
      `${API_BASE_URL}/log/${logId}/show`,
      {
        params: params,
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }
    );
    return response.data.data;
  }

  // Approve Selection
  async approveSelection(payload) {
    const response = await axios.post(`${this.resource}multi_approve`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async mentionCommentSearch(caseId){
    const response = await axios.get(
        `${API_BASE_URL}/software/${caseId}/mentionCommentSearch`, 
        {
            headers :   {
              Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
            }
        }
    );

    return response.data?.data;
  }

  async addEULocation(payload) {
    const response = await axios.post(`${this.resource}add_location`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async removeEULocation(payload) {
    const response = await axios.delete(`${this.resource}remove_location`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
        },
        data: payload // Pass the data here
    });

    return response.data.data;
  }

  async addNoneEULocation(payload) {
    const response = await axios.post(`${this.resource}add_none_eu_location`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }

  async removeNoneEULocation(payload) {
    const response = await axios.delete(`${this.resource}remove_none_eu_location`, {
        headers: {
            Authorization: `Bearer ${localStorage.getItem("LOCAL_STORAGE_KEY_ACCESS_TOKEN")}`
        },
        data: payload // Pass the data here
    });

    return response.data.data;
  }

  async changeType(payload) {
    const response = await axios.post(`${this.resource}change_type`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
        )}`,
      },
    });

    return response.data.data;
  }
  
    async toggleActivation(softwareId, payload = {}) {
        const response = await axios.put(`${this.resource}${softwareId}/toggle_inactive_status`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data;
    }

    
    async getSoftwareAssets() {
      const response = await axios.get(`${API_BASE_URL}/asset/index?type=software`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      });
    
      return response.data;
    }

    async getDataFlows(softwareId) {
      const response = await axios.get(`${this.resource}${softwareId}/data_flows`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      });
    
      return response.data;
    }

    async createDataFlow(payload) {
      const response = await axios.post(`${this.resource}data_flow/create`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      });
  
      return response.data.data;
    }

    async updateDataFlow(id, payload) {
      const response = await axios.post(`${this.resource}data_flow/${id}/update`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      });
  
      return response.data.data;
    }

    async deleteDataFlow(id) {
      const response = await axios.delete(`${this.resource}data_flow/${id}/delete`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
          )}`,
        },
      }, {});
  
      return response.data.data;
    }

    async fetchConformityExport(softwareId) {
        const response = await axios.get(
            `${this.resource}${softwareId}/conformity/export`,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`,
                },
            }
        );

        return response.data.data;
    }

    async approve(payload) {
        const response = await axios.post(`${this.resource}approve`, payload, {
            headers: {
                Authorization: `Bearer ${localStorage.getItem(
                    "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                )}`
            }
        });

        return response.data.data;
    }

    async checkSoftwareExistence(payload) {
        const response = await axios.post(`${this.resource}check_name`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        );

        return response.data.data
    }
}
